import React from "react";
import { useAuth } from "../config/AuthContext";
import { ROUTES } from "./routes";
import { Route, Redirect } from "react-router-dom";
const PrivateRoute = ({ component: Component, ...rest }) => {
  const { currentUser, moderator } = useAuth();

  return (
    <Route
      {...rest}
      render={(props) => {
        return currentUser && moderator ? (
          <Component {...props} />
        ) : (
          <Redirect to={ROUTES.HOME} />
        );
      }}
    ></Route>
  );
};

export default PrivateRoute;
